import { statusClass, label } from "@/lib/constants";

export function StatusBadge({ status, testid }) {
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${statusClass(status)}`}>
      {label(status)}
    </span>
  );
}

export function Plate({ value }) {
  return <span className="license-plate text-xs">{value || "—"}</span>;
}
